import { useEffect, useState } from 'react';

import { useApi } from '@backstage/core-plugin-api';

import { armApiRef } from '../api/ArmApiClient';

export type UserGroups = {
  groupIds: Set<string>;
  loading: boolean;
};

/**
 * Resolves the current user's Azure AD security-group memberships (via MS Graph
 * `/me/memberOf`). Used to gate KaaP tenant edit/delete actions against a
 * tenant's `spec.tenant.securityObjectIds`. On failure the set stays empty, so
 * actions remain disabled.
 */
export const useUserGroups = (): UserGroups => {
  const armApi = useApi(armApiRef);
  const [groupIds, setGroupIds] = useState<Set<string>>(new Set());
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    armApi
      .getGroups({ isMember: true })
      .then(groups => {
        if (!cancelled) {
          setGroupIds(new Set(groups.map(g => g.id)));
        }
      })
      .catch(() => {})
      .finally(() => {
        if (!cancelled) {
          setLoading(false);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [armApi]);

  return { groupIds, loading };
};
